import "components/ShoppableImage/ShoppableImage"
import EmptyLayout from "layout/EmptyLayout"
import AppLayout from "layout/AppLayout"
import RouteWithLayout from "layout/RouteWithLayout"
import RouteWithLogin from "layout/RouteWithLogin"
import { observer } from "mobx-react"
import LoginHandPage from "pages/LoginHandPage"
import SofortOrderPage from "pages/SofortOrderPage"
import SalesPage from "pages/SalesPage"
import React from "react"
import shop from "shop/shop"
import App from "theme/base/App"

import "./arnold.scss"
import CurrentCustomerHeader from "components/Header/CurrentCustomerHeader";

const BASE = shop.config.BASE

shop.config.printCollectionPage = true
shop.config.usePDFExport = true
shop.config.USE_OLD_SEARCH = true

console.log(shop.config);

@observer
class AppArnolds extends React.Component {

  render() {
    return <App
      before={<CurrentCustomerHeader/>}
    >

      <RouteWithLayout layout={EmptyLayout} path={"/login/accounts"} component={LoginHandPage}/>
      <RouteWithLayout layout={AppLayout} path={"/collection/sale/"} component={SalesPage}/>
      <RouteWithLayout layout={AppLayout} path={"/collection/sales/"} component={SalesPage}/>
      <RouteWithLogin layout={EmptyLayout} exact path={"/home/"} component={SofortOrderPage}/>
    </App>
  }
}

export default AppArnolds



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/App.js